import { Component, OnInit } from '@angular/core';
import { NewsModel } from './news.model';
import { RecentMandateModel } from './recent-mandate.model';
import { OrganizationManager } from '../../managers/organization.manager';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  standalone: false,
})
export class HomeComponent implements OnInit {
  public organizationName: string = 'Chargement en cours...';

  public events: any[] = [];

  public news: NewsModel[] = [];

  public recentMandates: RecentMandateModel[] = [];

  constructor(public organizationManager: OrganizationManager) {
  }

  async ngOnInit(): Promise<void> {
    const organization = await this.organizationManager.getCurrent();

    if (organization !== null) {
      this.organizationName = organization.name;
    }
  }

}
